<template>
  <div class="menu">
    <div class="items-row first-row">
      <div class="logo-center">
        <a class="cdp-translate" :href="href" target="_blank">
          <img src="./image/cdp.svg" alt="">
        </a>
      </div>
      <img class="light-bar" src="./image/light-bar.svg" alt="">
      <div class="logo-center">
        <a class="maw-translate" href="http://makeawish.org.hk/" target="_blank">
          <img src="./image/make-a-wish.svg" alt="">
        </a>
      </div>
    </div>

    <!-- <div class="items-row hamburger-bg">
      <img class="diamond-bg" @click="$emit('diamond')" src="./image/half-diamond.svg" alt="">
    </div> -->
    <div class="items-row hamburger">

      <!-- <img class="menu-line" src="./image/menu-line.svg" alt=""> -->
      <div class="left-bottom-bar"></div>

      <img class="diamond" @click="$emit('diamond')" src="./image/diamond.svg" alt="">

      <div class="right-bottom-bar"></div>
      <!-- <img class="menu-line" src="./image/menu-line.svg" alt=""> -->
    </div>
  </div>
</template>

<script>
import * as Text from '@/components/DOM/Text/Text.js'

export default {
  data () {
    return {
      get href () {
        return Text.state.U === Text.ENG ? 'http://www.cledepeau-beaute.com/int/' : 'http://www.cledepeau-beaute.com/hk/'
      }
    }
  }
}
</script>

<style scoped>
.menu{
  background-color: rgba(6, 12, 38, 0.8);
  color: white;
  width: 100%;
  height: 67.5px;
}
.items-row{
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.light-bar{
  transform: scaleX(0.5);
  /* transform: translateY(-5px); */
}
.logo-center{
  /* max-width: calc(960px / 2); */
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.items-row.hamburger{
  width: 100%;
  /* transform: translateY(-10px); */
}
.left-bottom-bar{
  width: calc(50% - 20px);
  height: 1px;
  background-color: #D3D3D3;
  transform: scaleY(0.5);
}
.right-bottom-bar{
  height: 1px;
  width: calc(50% - 20px);
  background-color: #D3D3D3;
  transform: scaleY(0.5);
}

/*
.menu-line{
  width: calc(50% - 20px);
}
*/

.items-row.first-row{
  height: 67px;
}
.diamond{
  cursor: pointer;
  width: 40px;
}

@media screen and (min-width: 320px) {
  /*iphone*/
  .diamond {
    transform: translate(0.2px, -19.35px);
  }
}

@media screen and (min-width: 960px) {
  /*desktop*/
  .diamond{
    transform: translate(0.2px, -19px);
  }
}

@media screen and (min-width: 1024px) {
  /*ipad*/
  .diamond{
    transform: translate(0.2px, -19.5px);
  }
}


@media screen and (width: 375px) and (height: 553px) {
  .diamond{
    transform: translate(0.2px, -19.5px);
  }
}



.diamond-bg{
  transform: translate3d(0px, 0.75px, 0px);
}
.items-row.hamburger-bg{
  position: absolute;
  left: calc(50% - 20px);
}
.items-row.hamburger-bg svg path{
  fill: rgba(0, 0, 0, 0.5);
}

.cdp-translate{
  transform: translateY(3px);
}
.maw-translate{
  transform: translateY(2px);
}
</style>



// WEBPACK FOOTER //
// src/components/DOM/FloatMenu/FloatMenu.vue